// extracted by mini-css-extract-plugin
export default {"resizeNone":"LabActionDetailsPopup_resizeNone__RpCeB","customWidth95":"LabActionDetailsPopup_customWidth95__ZH8xq"};